import { useState } from 'react';
import MenuReport from './MenuReport';
import OfficesReport from './OfficesReport';
import VariableExpensesReport from './VariableExpensesReport';
import FixedExpensesReport from './FixedExpensesReport';
import OtherRevenueReport from './OtherRevenueReport';
import RevenueReport from './RevenueReport';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import BusinessIcon from '@mui/icons-material/Business';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import BoltIcon from '@mui/icons-material/Bolt';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

type ReportTab = 'menu' | 'offices' | 'expenses' | 'fixed' | 'other' | 'revenue';

const tabs: { key: ReportTab; label: string; icon: JSX.Element }[] = [
  { key: 'menu', label: 'Menu', icon: <RestaurantMenuIcon fontSize="small" /> },
  { key: 'offices', label: 'Offices', icon: <BusinessIcon fontSize="small" /> },
  { key: 'expenses', label: 'Expenses', icon: <ReceiptLongIcon fontSize="small" /> },
  { key: 'fixed', label: 'Fixed Expenses', icon: <BoltIcon fontSize="small" /> },
  { key: 'other', label: 'Other Revenue', icon: <AddBusinessIcon fontSize="small" /> },
  { key: 'revenue', label: 'Running Dashboard', icon: <TrendingUpIcon fontSize="small" /> },
];

const Reports = () => {
  const [tab, setTab] = useState<ReportTab>('menu');

  return (
    <div className="p-4 md:p-6 max-w-[1200px] mx-auto space-y-6">
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-1.5 inline-flex gap-1">
        {tabs.map((t) => {
          const active = tab === t.key;
          return (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-semibold transition-all ${
                active
                  ? 'bg-slate-900 text-white shadow-sm'
                  : 'text-slate-600 hover:bg-slate-100'
              }`}
            >
              {t.icon}
              {t.label}
            </button>
          );
        })}
      </div>

      {tab === 'menu' && <MenuReport />}
      {tab === 'offices' && <OfficesReport />}
      {tab === 'expenses' && <VariableExpensesReport />}
      {tab === 'fixed' && <FixedExpensesReport />}
      {tab === 'other' && <OtherRevenueReport />}
      {tab === 'revenue' && <RevenueReport />}
    </div>
  );
};

export default Reports;
export { addMenuWarning } from './MenuReport';
